export default "__VITE_ASSET__f7805519__"